import { render, staticRenderFns } from "./RegionUpsert.vue?vue&type=template&id=5745eb44&"
import script from "./RegionUpsert.vue?vue&type=script&lang=js&"
export * from "./RegionUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports